import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { loadRelayConfig, type RelayConfig } from './api/client';
import { Layout } from './components/Layout';
import { SettingsGate } from './components/SettingsGate';
import { AccountDetail } from './pages/AccountDetail';
import { Accounts } from './pages/Accounts';
import { Comment } from './pages/Comment';
import { Proxies } from './pages/Proxies';
import { Settings } from './pages/Settings';
import { Warming } from './pages/Warming';

export default function App() {
  const [cfg, setCfg] = useState<RelayConfig | null>(loadRelayConfig());
  const [tick, setTick] = useState(0);

  useEffect(() => {
    setCfg(loadRelayConfig());
  }, [tick]);

  if (!cfg) {
    return <SettingsGate onSaved={() => setTick((t) => t + 1)} />;
  }

  return (
    <Layout onConfigCleared={() => setTick((t) => t + 1)}>
      <Routes>
        <Route path="/" element={<Accounts cfg={cfg} />} />
        <Route
          path="/accounts/:username"
          element={<AccountDetail cfg={cfg} />}
        />
        <Route path="/warming" element={<Warming cfg={cfg} />} />
        <Route path="/comment" element={<Comment cfg={cfg} />} />
        <Route path="/proxies" element={<Proxies cfg={cfg} />} />
        <Route path="/settings" element={<Settings cfg={cfg} />} />
      </Routes>
    </Layout>
  );
}
